module.exports = __webpack_public_path__ + "static/0001-06cfdab60a989d5bf7932548650c5e85.png";